import { render, staticRenderFns } from "./ProjectEditDialog.vue?vue&type=template&id=135348d4&"
import script from "./ProjectEditDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports